export default __webpack_public_path__ + "static/media/480_dummy2016-illustrator01-mobile-de.b2235ceb.png";